<template>
  <div class="header-content">
    <div class="communityName">
      <div
        v-if="userInfo.communties&&userInfo.communties.length<=1&&userInfo.communties.length>0"
      >{{userInfo.projectName}}</div>
      <div v-else class="dropmenu">
        <el-dropdown @command="changeCommunty" trigger="hover" class="communityText">
          <div>
            <span class="el-dropdown-link">
              {{userInfo.projectName}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
          </div>
          <el-dropdown-menu
            slot="dropdown"
            v-if="userInfo.communties&&userInfo.communties.length>0"
          >
            <el-dropdown-item
              :command="index"
              v-for="(item,index) in userInfo.communties"
              :key="index"
            >{{item.projectName}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div @click="refresh">
        <i class="el-icon-refresh-left"></i>
      </div>
    </div>
    <div class="right-operate">
      <img src="@/assets/images/codeicon.png" class="icon-code" @click="checkCode" />
      <el-dropdown @command="handleCommand" trigger="hover">
        <div>
          <span class="el-dropdown-link">
            {{userInfo.userName}}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="a">修改密码</el-dropdown-item>
          <el-dropdown-item command="b">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- 查看二维码弹窗 -->
    <el-dialog :visible.sync="codeDiaVisible" class="code-dialog" width="768px">
      <div class="codeInfo">
        <div>
          <img src="@/assets/images/wechat.jpg" alt />
          <div class="codeText">
            <img src="@/assets/images/wx.png" alt height="21" />
            <span>微信小程序</span>
          </div>
        </div>
        <div>
          <img src="@/assets/images/andriodCode.png" alt />
          <div class="codeText">
            <img src="@/assets/images/android.png" alt height="21" />
            <span>微信小程序</span>
          </div>
        </div>
      </div>
      <p>右键保存二维码</p>
    </el-dialog>
    <!-- 修改密码 -->
    <el-dialog
      title="修改密码"
      :visible.sync="resetPwdDiaVisible"
      class="rebackPwd-dialog"
      width="360px"
    >
      <el-form
        :model="reqData"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
        class="demo-ruleForm"
      >
        <el-form-item label="原始密码" prop="oldPassword">
          <el-input type="password" v-model.trim="reqData.oldPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            type="password"
            v-model.trim="reqData.newPassword"
            autocomplete="off"
            placeholder="请输入6~15位大小写字母或数字"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="newPasswordAgain">
          <el-input type="password" v-model.trim="reqData.newPasswordAgain" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="text" @click="resetPwdDiaVisible = false">取 消</el-button>
        <el-button type="primary" @click="resetPwd('ruleForm')">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import api from "@/api/index.js";
import { dealData } from "@/utils/auth.js";
export default {
  name: "Header",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else {
        if (this.reqData.newPasswordAgain !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.reqData.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      codeDiaVisible: false,
      resetPwdDiaVisible: false,
      reqData: {
        oldPassword: "",
        newPassword: "",
        newPasswordAgain: ""
      },
      rules: {
        oldPassword: [
          { required: true, message: "请输入原密码", trigger: "blur" }
        ],
        newPassword: [
          { required: true, message: "请输入原密码", trigger: "blur" },
          {
            pattern: /^[a-zA-Z0-9]{6,15}$/,
            message: "请输入6~15位大小写字母或数字",
            trigger: "blur"
          },
          { validator: validatePass, trigger: "blur" }
        ],
        newPasswordAgain: [
          { required: true, message: "请输入原密码", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    }
  },
  methods: {
    refresh() {
      if (!this.$route.path.includes("iframe")) {
        this.$router.replace({
          path: "/refresh"
        });
        return false;
      }
      this.$store.commit("SET_REFRESH_PATH", this.$route.fullPath);
    },
    checkCode() {
      this.codeDiaVisible = true;
    },
    // 名字点击下拉框
    handleCommand(command) {
      switch (command) {
        case "a":
          this.resetPwdDiaVisible = true;
          break;
        case "b":
          this.loginOut();
          break;
        default:
          break;
      }
    },
    // 社区下拉框
    changeCommunty(index) {
      let data = this.userInfo;
      if (!data.communties || data.communties.length <= 0) return;
      data.communityId = data.communties[index].projectId;
      Object.assign(data, data.communties[index]);
      this.$store.commit("SET_USER", data);
      this.$router.push("/");
      this.$store.commit("DEL_TABS");
      this.getMenu();
    },

    async getMenu() {
      let data = {
        userId: this.$store.state.userInfo.userId,
        communityId: this.$store.state.userInfo.communityId,
        viewType: 1
      };
      let res = await this.$http.get(api.getMenu, {
        params: data,
        loading: true
      });
      if (res && res.isSucceed) {
        dealData(res.rows);
        this.$store.commit("SET_ROUTERS", res.rows);
        this.$router.push("/");
      }
    },

    loginOut() {
      this.$store.commit("DEL_TOKEN");
      this.$router.push("/login");
      sessionStorage.clear();
    },
    resetPwd(formName) {
      this.$refs[formName].validate(async valid => {
        if (!valid) return false;
        let data = JSON.parse(JSON.stringify(this.reqData));
        delete data.newPasswordAgain;
        let res = await this.$http.post(api.resetPwd, this.$qs.stringify(data));
        if (res && res.code === 200) {
          this.$message({
            message: "密码修改成功",
            type: "success"
          });
          this.resetPwdDiaVisible = false;
        }
      });
    }
  }
};
</script>
<style lang='less' scoped>
@import url("./header.less");
</style>
<style lang='less'>
@import url("./ele-header.less");
</style>